<app-cer-add-edit [type]="'add'" />